<template>
    <div class="t-day t-day_small" :class="{'t-day_active': active, 't-day_select': select}" @click.prevent="SetDay()">
        <p class="t-day__date">{{ day }}</p>
    </div>
</template>

<script>
    import {store} from '../../store/index'

    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    export default {
        props: ['day'],
        data(){
            return {
                select : false
            }
        },
        computed: {
            ...mapGetters('calendar_small', ['date_active', 'open_day']),
            ...mapGetters('coursesList', ['streams']),
            active(){
                this.select = false;

                let lessons_count = 0;

                let date = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.day;

                for(let s = 0; s < this.streams.length; s++){
                    let stream = this.streams[s];

                    for(let l = 0; l < stream.lessons.length; l++) {
                        let lesson = stream.lessons[l];

                        let day = new Date(lesson.date_time);
                        let date_2 = day.getFullYear() + '.' + (day.getMonth() + 1) + '.' + day.getDate();

                        if(date_2 === date){
                            lessons_count++;

                            let date_open = this.open_day.getFullYear() + '.' + (this.open_day.getMonth() + 1) + '.' + this.open_day.getDate();
                            if(date_2 === date_open){
                                this.select = true;
                            }
                        }
                    }
                }

                return lessons_count > 0
            }
        },
        methods: {
            ...mapActions('calendar_small', ['SetOpenDay']),
            SetDay(){
                let date = new Date(this.date_active.getFullYear() + '-' + (this.date_active.getMonth() + 1) + '-' +  this.day);

                this.SetOpenDay(date);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/vue_components/Calendar_small/Day.vue